// extracted by mini-css-extract-plugin
module.exports = {"container":"MainContainerStyle_container__1cSmY"};